import { EventType } from '../scheduling/types';
export const rowKeyForEvent = (eventId) => `event-${eventId}`;
export const rowKeyForAdhocLeg = (legId) => `leg-${legId}`;
export const rowKeyForTechnicalChange = (changeId) => `cc-${changeId}`;
export const FLIGHT_EVENT_TYPES = new Set([
    EventType.charter_flight,
    EventType.ferry_flight,
    EventType.leg,
    EventType.owner_flight,
    EventType.rental_flight,
    EventType.training_flight,
    EventType.wet_lease_flight,
]);
//# sourceMappingURL=rowKeys.js.map